export const pieChartSize = "500px";
export const barChartHeight = "400px";
